import {SurveyPayload} from "infrastructure/services/surveyResponse.service";

const TOKEN_MAP_KEY = "NOM035_tokenMap";

type TokenEntry = { pendingSubmission?: SurveyPayload } & Record<string, unknown>;
type TokenMap = Record<string, TokenEntry>;

function readMap(): TokenMap {
    try {
        const raw = localStorage.getItem(TOKEN_MAP_KEY);
        return raw ? (JSON.parse(raw) as TokenMap) || {} : {};
    } catch {
        console.error("[pendingSubmissions] NOM035_tokenMap ilegible; no se toca");
        return {};
    }
}

function writeMap(map: TokenMap): boolean {
    try {
        localStorage.setItem(TOKEN_MAP_KEY, JSON.stringify(map));
        return true;
    } catch (error) {
        console.error("[pendingSubmissions] no se pudo escribir NOM035_tokenMap", error);
        return false;
    }
}

export function savePendingSubmission(payload: SurveyPayload): boolean {
    const map = readMap();
    const current = map[payload.token] || {};
    map[payload.token] = {...current, pendingSubmission: payload};
    return writeMap(map);
}

export function removePendingSubmission(token: string): void {
    const map = readMap();
    const current = map[token];
    if (!current?.pendingSubmission) return;
    const {pendingSubmission, ...resto} = current;
    map[token] = resto;
    writeMap(map);
}

export function listPendingSubmissions(): SurveyPayload[] {
    return Object.values(readMap())
        .map(entry => entry?.pendingSubmission)
        .filter((payload): payload is SurveyPayload => !!payload?.token && !!payload?.responses);
}
